import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { composeUsername } from 'features/user/utils/composeUsername'
import { unwrapGitDiffForMonacoDiffViewer } from 'utils/git'
import { BuildOrderForTable, BuildOrderSortBy } from '../types'
import { DEFAULT_USER_NAME } from './constants'
import { BuildOrderForTableDTO, BuildOrderSortByDTO } from './types'

export const fromDTO = (from: BuildOrderForTableDTO): BuildOrderForTable =>
  mapDTO<BuildOrderForTableDTO, BuildOrderForTable>({ from }).transform(
    (dto: BuildOrderForTableDTO): BuildOrderForTable => {
      const { buildOrderRequester, changes, updatedAt, ...buildOrder } = dto

      return {
        ...buildOrder,
        changes:
          changes == null || changes.length === 0
            ? undefined
            : unwrapGitDiffForMonacoDiffViewer(changes),
        updatedAt: new Date(updatedAt),
        username: usernameBuilder(buildOrderRequester),
      }
    },
  )

export const sortToDTO = (sort: SortInput<BuildOrderSortBy>): SortInput<BuildOrderSortByDTO> => {
  const { by } = sort

  if (by === 'domain.name') {
    return { ...sort, by: 'domainName' }
  } else {
    return { ...sort, by }
  }
}

export const usernameBuilder = (
  buildOrderRequester: BuildOrderForTableDTO['buildOrderRequester'],
): string => {
  if (!buildOrderRequester) {
    return DEFAULT_USER_NAME
  }

  return composeUsername({ ...buildOrderRequester }) ?? DEFAULT_USER_NAME
}
